"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateSequence = exports.evaluate = exports.evaluateProgram = exports.evaluators = void 0;
const errors = require("../errors/errors");
const sExpression_1 = require("../sExpression");
const macro_1 = require("./macro");
const procedure_1 = require("./procedure");
const converters_1 = require("./specialForm/converters");
const evaluators_1 = require("./specialForm/evaluators");
const util_1 = require("./util");
function* visit(context, node) {
    context.runtime.nodes.unshift(node);
    // Start each node in non-tail context
    // The evaluator for the node can change this to true when it enters tail context
    context.runtime.inTailContext.unshift(false);
    yield context;
}
function* leave(context) {
    context.runtime.nodes.shift();
    context.runtime.inTailContext.shift();
    yield context;
}
exports.evaluators = {
    list: function* (node, context) {
        if (node.elements.length === 0) {
            // Empty list - return empty list
            return sExpression_1.makeEmptyList();
        }
        const firstElement = node.elements[0];
        if (firstElement.type === 'symbol' && !util_1.getVariable(context, firstElement.value)) {
            // No procedure bound to the name - treat it as a special form
            const specialForm = converters_1.listToSpecialForm(firstElement.value, node, context);
            if (!specialForm) {
                return util_1.handleRuntimeError(context, new errors.UndefinedVariable(firstElement.value, node));
            }
            return yield* evaluators_1.evaluateSpecialForm(specialForm, context);
        }
        const firstElementValue = yield* evaluate(firstElement, context);
        if (firstElementValue.type === 'procedure') {
            // Procedure invocation
            const procedure = firstElementValue;
            const args = yield* procedure_1.listOfArguments(node.elements.slice(1), context);
            if (procedure_1.isParentInTailContext(context)) {
                const tailCall = {
                    type: 'TailCall',
                    procedure,
                    args,
                    node
                };
                return tailCall;
            }
            else {
                return yield* procedure_1.apply(context, procedure, args, node);
            }
        }
        else if (firstElementValue.type === 'macro') {
            // Macro use
            const macro = firstElementValue;
            return yield* macro_1.useMacro(context, macro, node.elements.slice(1), node);
        }
        else {
            return util_1.handleRuntimeError(context, new errors.CallingNonFunctionValue(firstElementValue, node));
        }
    },
    'dotted list': function* (node, context) {
        return util_1.handleRuntimeError(context, new errors.UnexpectedDottedList(node));
    },
    string: function* (node) {
        return sExpression_1.makeString(node.value);
    },
    number: function* (node) {
        return sExpression_1.makeNumber(node.value);
    },
    boolean: function* (node) {
        return sExpression_1.makeBool(node.value);
    },
    symbol: function* (node, context) {
        const boundValue = util_1.getVariable(context, node.value);
        if (boundValue) {
            return boundValue;
        }
        else {
            return util_1.handleRuntimeError(context, new errors.UndefinedVariable(node.value, node));
        }
    }
};
function* evaluateProgram(program, context) {
    context.numberOfOuterEnvironments += 1;
    const environment = util_1.extendCurrentEnvironment(context, 'programEnvironment');
    util_1.pushEnvironment(context, environment);
    let result;
    for (const expression of program.body) {
        result = yield* evaluate(expression, context);
    }
    if (result.type === 'TailCall') {
        return util_1.handleRuntimeError(context, new errors.UnreachableCodeReached('top-level eval should not return a TailCall object'));
    }
    return result;
}
exports.evaluateProgram = evaluateProgram;
function* evaluate(node, context) {
    yield* visit(context, node);
    const evaluator = exports.evaluators[node.type];
    const result = yield* evaluator(node, context);
    yield* leave(context);
    return result;
}
exports.evaluate = evaluate;
function* evaluateSequence(expressions, context, isTailSequence, defaultResult) {
    if (expressions.length === 0) {
        if (defaultResult !== undefined) {
            return defaultResult;
        }
        return util_1.handleRuntimeError(context, new errors.UnreachableCodeReached('a sequence should have at least one form'));
    }
    for (let i = 0; i < expressions.length - 1; i++) {
        const expression = expressions[i];
        yield* evaluate(expression, context);
    }
    const lastExprression = expressions[expressions.length - 1];
    if (isTailSequence) {
        // evaluate the last expression in tail context
        procedure_1.tryEnterTailContext(context);
    }
    return yield* evaluate(lastExprression, context);
}
exports.evaluateSequence = evaluateSequence;
//# sourceMappingURL=interpreter.js.map